/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { z } from 'zod';
import type { IAPI } from '../../apiResponse';
import { createApiResponseSchema } from '../../apiResponse';
import { collectionWithCountsSchema } from '../collection-schema';

export const listAllCollectionsResponseDataSchema = z.array(collectionWithCountsSchema);

export type IListAllCollectionsResponseData = z.infer<typeof listAllCollectionsResponseDataSchema>;

export const listAllCollectionsResponseSchema = createApiResponseSchema(
  listAllCollectionsResponseDataSchema,
) as z.ZodSchema<IAPI<IListAllCollectionsResponseData>>;

export type IListAllCollectionsResponse = IAPI<IListAllCollectionsResponseData>;
